<template>
  <div class="flex flex-col gap-2">
    <InfuseNegatableFilter
      :model-value="negated"
      @update:model-value="(newValue) => valuesChanged(query, newValue)"
      :comparison-type="comparisonType"
    >
      <InfuseInput
        size="xs"
        :model-value="query"
        :placeholder="modelValue.label()"
        required
        @update:model-value="(newQuery) => valuesChanged(newQuery, negated)"
      />
    </InfuseNegatableFilter>
  </div>
</template>

<script lang="ts" setup>
import { ComparisonType, FilterOption } from '@infuse/ui/domain';
import { onMounted, Ref, ref } from 'vue';
import { InfuseNegatableFilter } from '../../index';
import InfuseInput from '../InfuseInput.vue';

interface Props {
  modelValue: FilterOption;
  comparisonType?: ComparisonType;
}

const props = withDefaults(defineProps<Props>(), {
  comparisonType: ComparisonType.EQ
});

interface Emits {
  (e: 'apply:value', spec: FilterOption, negated: boolean, value?: string): void;

  (e: 'validationChange', valid: boolean): void;
}

const emit = defineEmits<Emits>();

const query: Ref<string> = ref('');
const negated = ref(false);

onMounted(() => {
  valuesChanged('', negated.value);
});

function valuesChanged(newQuery: string, newNegated: boolean): void {
  negated.value = newNegated;
  query.value = newQuery;

  emit('apply:value', props.modelValue, negated.value, query.value);
  emit('validationChange', !!query.value || query.value !== '');
}
</script>
